import { ConditionRegistryCategory } from '../../../registry/condition/ConditionRegistryCategory';
import { ConditionsOrderedOption } from './ConditionsOrderedOption';
import { ConditionRegistryOrderedTask } from './ConditionRegistryOrderedTask';
import { ConditionsOrderedStep } from './ConditionsOrderedStep';
export class ConditionsOrderedChoice extends ConditionRegistryCategory {
    label = 'OrderedChoice';
    c_option = new ConditionsOrderedOption(this);
    c_task = new ConditionRegistryOrderedTask(this);
    c_step = new ConditionsOrderedStep(this);
}
